
import _, { get } from 'lodash';
import { mapGetters, mapState } from 'vuex';
import API from '@/api';

import {
  canAccountViewCompanyBookedLoads,
  canAccountViewCompanyBids,
  canAccountViewCompanyLoadSettlements,
  accountHasCreateListingPermission,
} from '@/store/permissions';

import { hasLoadingChutes } from '@/types/models/company';
import EffectivePlugins from '@/ltnplugins/EffectivePlugins';

export default {
  computed: {
    ...mapState('profiles', ['userProfile']),
    ...mapGetters('profiles', [
      'featureFlags',
      'isLtnAdmin',
    ]),
    ...mapGetters('companies', [
      'companies',
      // 'getCompanyInfo',
    ]),
    ...mapGetters('plugins', [
      'siteDesignation',
    ]),

    async companiesWithOptions() {
      const accounts = this.userProfile.companyAccounts;
      const withOptions = [];
      for (const companyAccount of this.userProfile.companyAccounts) {
        const companyInfo = this.getCompanyInfo(companyAccount.companyId);
        withOptions.push(await this.companyWithOptions(companyAccount, companyInfo));
      }
      return withOptions;
    },
    _() {
      return _;
    },
  },
  methods: {
    getCompanyInfo(id){
      return this.companies.find((company) => company.id === id);
    },
    companyWithOptions(companyAccount, fullCompanyInfo = null){
      if (!companyAccount && !fullCompanyInfo) {
        return;
      }

      if (!companyAccount && this.isLtnAdmin) {
        companyAccount = {
          companyId: fullCompanyInfo.id,
          companyDisplayName: fullCompanyInfo.companyName,
        };
      }

      const userFlags = this.featureFlags;
      console.log('Provided full company Info', fullCompanyInfo);
      if (!fullCompanyInfo) {
        fullCompanyInfo = this.getCompanyInfo(companyAccount.companyId);
      }

      if (!fullCompanyInfo) {
        console.log('No full company info. what is it?', companyAccount)
        fullCompanyInfo = companyAccount;
      }

      const siteDesignation = this.siteDesignation;
      const effectivePlugins = EffectivePlugins.assemble(siteDesignation);
      const loadboardBiddingEnabled = effectivePlugins.loadboard.enableBidding;
      const companyId = fullCompanyInfo.id;

      const options = [];

      if ((loadboardBiddingEnabled && canAccountViewCompanyBids(companyAccount) || this.isLtnAdmin) &&
        get(fullCompanyInfo, 'truckingInfo.dotNumber', false)) {
        options.push({ title: 'Placed Bids', link: `/companies/${companyId}/placed-bids`, icon: 'attach_money' });
      }

      if (accountHasCreateListingPermission(companyAccount) || this.isLtnAdmin) {
        options.push({ title: 'Loads', link: `/companies/${companyId}/loads`, icon: 'event' });
      }

      if ((canAccountViewCompanyBookedLoads(companyAccount)  || this.isLtnAdmin) && hasLoadingChutes(fullCompanyInfo)) {
        options.push({ title: 'Receiving', link: `/companies/${companyId}/receiving`, icon: 'event' });
      }

      if (canAccountViewCompanyLoadSettlements(companyAccount) || this.isLtnAdmin) {
        options.push({ title: 'Transactions', link: `/companies/${companyId}/transactions`, icon: 'payment' });
      }

      options.push({ title: 'Company Profile', link: `/companies/${companyId}/profile`, icon: 'business' });

      return {
        ...companyAccount,
        options,
      };
    },
  }
}



// WEBPACK FOOTER //
// ./src/mixins/profileMixin.js